module.exports = __webpack_public_path__ + "img/users.9c2cfbaa.svg";